import { environment } from "src/environments/environment";

export const Encryptor = {
	encrypt(data: string): string {
		const encryptionKey = environment.encryptionKey

		if (!encryptionKey) {
			throw new Error('Encryption key is not defined in the environment settings');
		}

		const key = btoa(encryptionKey);
		return btoa(unescape(encodeURIComponent(data + key)));
	},

	decrypt(encryptedData: string): string {
		const encryptionKey = environment.encryptionKey

		if (!encryptionKey) {
			throw new Error('Encryption key is not defined in the environment settings');
		}

		const key = btoa(encryptionKey);
		const decoded = decodeURIComponent(escape(atob(encryptedData)));
		return decoded.replace(key, '');
	}
}


export function generatePaymentId(): string {
	const randomId = Math.floor(Math.random() * 9000000000) + 1000000000;
	return randomId.toString();
}

export function formatTime(seconds: number): string {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = parseInt(`${seconds % 60}`);

	// Asegurarse de que los números estén en formato de 2 dígitos
	const formattedMinutes = String(minutes).padStart(2, '0');
	const formattedSeconds = String(remainingSeconds).padStart(2, '0');

	return seconds > 0 ? `${formattedMinutes}:${formattedSeconds}` : '00:00';
}
